"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _useGetUser = _interopRequireDefault(require("./useGetUser"));
var _jsxRuntime = require("react/jsx-runtime");
var _g;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const sizeClasses = {
  tiny: "size-[12px] min-h-[12px] min-w-[12px]",
  normal: "size-[24px] min-h-[24px] min-w-[24px]",
  large: "size-[50px] min-h-[50px] min-w-[50px]"
};
const ProfileImage = _ref => {
  var _user$displayName, _ref2;
  let {
    imgSize = "normal"
  } = _ref;
  const [imgLoadError, setImgLoadError] = React.useState(false);
  const user = (0, _useGetUser.default)();
  const name = (_user$displayName = user === null || user === void 0 ? void 0 : user.displayName) !== null && _user$displayName !== void 0 ? _user$displayName : "";
  const url = user === null || user === void 0 ? void 0 : user.photo;
  const socialImageUrl = user === null || user === void 0 ? void 0 : user.socialAvatar;
  if (url == null && socialImageUrl == null || imgLoadError) {
    return (
      /*#__PURE__*/
      // Converted from svg with https://svg2jsx.com/
      (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 64",
        className: sizeClasses[imgSize],
        "data-test": "TopNav-AccountIcon",
        children: _g || (_g = /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          fill: "none",
          fillRule: "evenodd",
          stroke: "none",
          strokeWidth: "1",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            fill: "#E8EDF1",
            transform: "translate(-80 -82)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                transform: "translate(80 82)",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                      d: "M32 0c17.664 0 32 14.336 32 32S49.664 64 32 64 0 49.664 0 32 14.336 0 32 0zm.005 36.683c-12.56 0-21.333 6.578-21.333 16l.115.53.35.345c11.617 11.249 30.104 11.25 41.723.003l.353-.348.126-.53-.003-.307c-.188-9.257-8.905-15.693-21.33-15.693zm0-24c-5.882 0-10.666 4.786-10.666 10.666 0 5.88 4.786 10.667 10.666 10.667 5.883 0 10.667-4.787 10.667-10.667s-4.784-10.666-10.667-10.666z"
                    })
                  })
                })
              })
            })
          })
        }))
      })
    );
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions -- to allow onError
    (0, _jsxRuntime.jsx)("img", {
      className: (0, _clsx.default)("relative rounded-full", sizeClasses[imgSize]),
      "data-test": "TopNav-ProfileImage",
      onError: () => setImgLoadError(true),
      src: (_ref2 = url !== null && url !== void 0 ? url : socialImageUrl) !== null && _ref2 !== void 0 ? _ref2 : "",
      alt: name
    })
  );
};
var _default = exports.default = ProfileImage;